import { render } from "./BarChart.vue?vue&type=template&id=17d73545&scoped=true"
import script from "./BarChart.vue?vue&type=script&lang=js"
export * from "./BarChart.vue?vue&type=script&lang=js"

import "./BarChart.vue?vue&type=style&index=0&id=17d73545&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17d73545"]])

export default __exports__